import {
  errorUnlessOk,
  buildRequestWithAuth,
  headersBackendSeguros,
} from "./utils";
import environment from "~libs/environment";
import { GetTiposCoberturaResponse } from "./types";

const tiposCobertura = () => {
  return {
    getTiposCobertura: (): Promise<GetTiposCoberturaResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      return fetch(`${environment.segurosUrl}/tiposCoberturas`, request)
        .then(errorUnlessOk)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

export { tiposCobertura };
